import React from "react";

export default function SectionTitle({title, subtitle, icon, onClick, rightIcon, badge}) {
    const customClass = onClick ? "onclick" : "";

    function displayRightIcon() {
        if (rightIcon) {
            return (
                <span className="right-icon">{rightIcon}</span>                
            )
        }
    }

    function displayBadge() {
        if (badge)
            return (
                <div className="d-inline ms-5">
                    {badge}
                </div>                
            )
    }

    return (
        <div className={`section-title ${customClass}`} onClick={onClick}>
            <div>
                <h2 className="title">{icon} {title} {displayBadge()} {displayRightIcon()}</h2>                
            </div>
            
            <span className="subtitle">{subtitle}</span>            
        </div>
    )
}